import { Autocomplete } from '@mui/material';
import { TGetEditResourceFormAutoComplete } from '~/components/Admin/AdminComponent.type';
import { StyledTextField } from '../../ResourceFilter/ResourceFilter.style';
import { admin } from '../AdminDialog.style';
import { resourceCategory } from '~/api/oneBoxV3/oneBoxV3.type';

export const EditDialogAutocomplete = ({
  id,
  values,
  customOptions,
  editedResource,
  isFreesolo,
  handleEdit,
  errorProps,
}: TGetEditResourceFormAutoComplete) => {
  return (
    <Autocomplete
      value={values[`${id}`]}
      id={id}
      size="small"
      multiple
      freeSolo={isFreesolo}
      limitTags={3}
      options={customOptions}
      getOptionDisabled={option => option === editedResource[`${id}`].origin}
      renderInput={params => (
        <StyledTextField {...params} {...errorProps(id)} />
      )}
      fullWidth
      onChange={(_event, newValue) => handleEdit({ newValue, id })}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => {
          if (!option) return;
          const isDefault = option === editedResource[`${id}`].origin;
          return (
            <admin.Chip
              variant={isDefault ? 'filled' : 'outlined'}
              label={option}
              {...getTagProps({ index })}
              key={option}
              isDefault={isDefault}
            />
          );
        })
      }
    />
  );
};

// isOptionEqualToValue 讓下拉選單 select 學校選項
// renderTags 不顯示補教 tag
export const SchoolEditDialogAutocomplete = ({
  id,
  values,
  customOptions,
  isFreesolo,
  handleEdit,
  errorProps,
}: TGetEditResourceFormAutoComplete) => {
  return (
    <Autocomplete
      value={values[`${id}`]}
      id={id}
      size="small"
      multiple
      freeSolo={isFreesolo}
      limitTags={3}
      options={customOptions}
      getOptionDisabled={option => !!option}
      isOptionEqualToValue={option =>
        option === (resourceCategory.SCHOOL as string)
      }
      renderInput={params => (
        <StyledTextField {...params} {...errorProps(id)} />
      )}
      fullWidth
      onChange={(_event, newValue) => handleEdit({ newValue, id })}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => {
          if (!option || option === (resourceCategory.CRAM_SCHOOL as string))
            return;
          return (
            <admin.Chip
              variant={'filled'}
              label={option}
              {...getTagProps({ index })}
              key={option}
              isDefault={true}
            />
          );
        })
      }
    />
  );
};
